module.exports = __webpack_public_path__ + "media/images/team_communication-dde13649.svg";